import React from 'react';
import styled from 'styled-components';

import { StyledLink } from 'shared/components';
import { mediaQueries } from 'shared/styles';

import useTranslation from 'hooks/use-translation';
import { useInternalLogin } from './use-internal-login';

export function InternalLogin(): JSX.Element {
  const { t } = useTranslation();
  const {
    onClickLogin,
    onClickSignup,
    onClickLogoutExternalUser,
    isIsolatedCheckout,
    isNotLoggedIn,
    disableGuestCheckout,
    userHasExternalUser,
    isMobileApp,
  } = useInternalLogin();

  return (
    <>
      {isNotLoggedIn && !disableGuestCheckout && !userHasExternalUser && (
        <LoginText isMobileApp={isMobileApp}>
          <LoginButton
            onClick={onClickLogin}
            data-cy='login-button'
            data-test='login-button'
            data-testid='login-button'
          >
            {t('checkout.login-button', 'Log in')}
          </LoginButton>
          <LoginButton
            onClick={onClickSignup}
            data-cy='signup-button'
            data-test='signup-button'
            data-testid='signup-button'
          >
            {t('checkout.signup-button', 'Sign up')}
          </LoginButton>
        </LoginText>
      )}

      {userHasExternalUser && !isIsolatedCheckout && (
        <LoggedInText isMobileApp={isMobileApp}>
          {t('checkout.different-account', 'Need to use a different account?')}{' '}
          <StyledLink as='button' onClick={onClickLogoutExternalUser} data-cy='login-button' data-test='login-button'>
            {t('checkout.logout-button', 'Logout')}
          </StyledLink>
        </LoggedInText>
      )}
    </>
  );
}

const LoginText = styled.div`
  display: flex;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  gap: 12px;
`;

const LoginButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: #121516;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 0;

  &:not(:last-child) {
    border-right: 1px solid #d9d9d9;
    padding-right: 12px;
  }
`;

const LoggedInText = styled.span`
  color: ${({ theme }) => theme.colors.v2TextColor1};
  display: inline-block;
  font-size: 13px;
  line-height: 1.325;
  padding: ${({ isMobileApp }) => (isMobileApp ? `15px 30px 15px` : `none`)};

  @media ${mediaQueries.phone} {
    font-size: 12px;
  }
`;
